export default __webpack_public_path__ + "351f994957bbce29d4e0509e06d076d4.svg";